import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import { ScrollToTop } from "@/components/ScrollToTop";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Cometa from "@/pages/Cometa";
import Podcast from "@/pages/Podcast";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Tejido from "@/pages/Tejido";
import Mapa from "@/pages/Mapa";
import Contacto from "@/pages/Contacto";
import MarcaHome from "@/pages/marca/MarcaHome";
import Experiencias from "@/pages/marca/Experiencias";
import ExperienciaDetalle from "@/pages/marca/ExperienciaDetalle";
import ComoFunciona from "@/pages/marca/ComoFunciona";
import Regala from "@/pages/marca/Regala";
import UtopistasBlog, { UtopistasPost } from "@/pages/marca/UtopistasBlog";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <HelmetProvider>
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/admin" element={<Admin />} />
          <Route path="/*" element={
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/cometa" element={<Cometa />} />
                <Route path="/podcast" element={<Podcast />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/tejido" element={<Tejido />} />
                <Route path="/constelacion" element={<Mapa />} />
                <Route path="/mapa" element={<Navigate to="/constelacion" replace />} />
                <Route path="/contacto" element={<Contacto />} />
                <Route path="/marca" element={<MarcaHome />} />
                <Route path="/marca/experiencias" element={<Experiencias />} />
                <Route path="/marca/experiencias/:slug" element={<ExperienciaDetalle />} />
                <Route path="/marca/como-funciona" element={<ComoFunciona />} />
                <Route path="/marca/regala" element={<Regala />} />
                <Route path="/marca/blog" element={<UtopistasBlog />} />
                <Route path="/marca/blog/:slug" element={<UtopistasPost />} />
                <Route path="/marca/contacto" element={<Contacto />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Layout>
          } />
        </Routes>
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
